<template>
    <div id="app">
        <transition-page>
            <router-view
                    @notification-permission="checkNotificationPermissions"
                    @check-login="checkLoginHandler"
            />
        </transition-page>
        <Loader/>

    </div>
</template>

<script>
import Loader from "./components/Loader";
import {mapGetters, mapMutations} from "vuex";
import {errorMessage} from "./services/messges";
import TransitionPage from './components/TransitionPage.vue';
import SmartBanner from "smart-app-banner";

export default {
    data() {
        return {
            banner: null
        };
    },
    mounted() {
        this.initSmartBanner();
    },
    methods: {
        ...mapMutations([
            'setLogged',
            'setLoading',
            'setLoginChecked',
            'set_after_login',
        ]),
        initSmartBanner() {
            this.banner = new SmartBanner({
                daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
                daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
                appStoreLanguage: 'us', // language code for the App Store (defaults to user's browser language)
                title: 'Speedfrending',
                author: 'Digital Speedfrending Inc.',
                button: 'VIEW',
                store: {
                    ios: 'On the App Store',
                    android: 'In Google Play',
                    // windows: 'In Windows store'
                },
                price: {
                    ios: 'FREE',
                    android: 'FREE',
                    // windows: 'FREE'
                }
                // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
                // , icon: '' // full path to icon image if not using website icon image
                // , force: 'ios' // Uncomment for platform emulation
            });
        },
        async checkNotificationPermissions() {
            try {
                const permission = await Notification.requestPermission();
                if (permission === "granted") {
                    await this.saveFCMToken();
                    this.$messaging.onTokenRefresh(async () => {
                        await this.saveFCMToken();
                    })
                } else {
                    console.log('FIREBASE PERMISSIONS NOT GRANTED');
                    return false;
                }
            } catch (e) {
                console.log(e);
            }
            return false;
        },
        async saveFCMToken() {
            try {
                const token = await this.$messaging
                    .getToken({vapidKey: "BJARa1Jy6dNFocrOLXkRtUgGd_vQdsPzrOTBkKGl2C_KCt-KTr9hQUpI-qqniU1WOT1KrPnXZm_9IRGvWRUw2G4"});

                const old_token = localStorage.getItem('firebase_token');
                const is_after_login = this.is_after_login;
                console.log('saveFCMToken', {token, old_token, is_after_login});
                if (token !== old_token || is_after_login) {
                    try {
                        const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/push_token`, {
                            token,
                            old_token
                        });
                        if (response && response.data && response.data.success) {
                            localStorage.setItem('firebase_token', token);
                        }
                    } catch (e) {
                        errorMessage(e?.response?.data?.error?.message);
                    }
                    this.set_after_login(false);
                }

                return true;
            } catch (e) {
                console.log(e);
            }
            return false;
        },
        async checkLoginHandler(path = '/') {
            if (!this.isLogged || !this.isLoginChecked) {
                try {
                    await this.$http.refreshToken();
                    this.setLogged(true);
                    this.setLoginChecked(true);
                } catch (e) {
                    if (e.response && e.response.status === 403) {
                        this.setLoading(false);
                        this.$nextTick(async () => {
                            await this.$router.push(path);
                        });
                    }
                } finally {
                    this.$nextTick(() => {
                        console.log('$nextTick checkLoginHandler')
                        this.setLoading(false);
                    })
                }
                console.log('end checkLoginHandler')
            }
        }
    },
    computed: {
        ...mapGetters([
            'isLogged',
            'isLoginChecked',
            'is_after_login',
        ])
    },
    components: {
        Loader,
        TransitionPage
    }
}
</script>

<style lang="scss">
@import '~materialize-css/dist/css/materialize.min.css';
@import "assets/scss/variables";
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700;900&display=swap');

html, body {
  font-family: 'Source Sans Pro', sans-serif;
  margin: 0;
  padding: 0;
  font-size: 15px;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  height: 100%;
}

[type="checkbox"].filled-in:not(:checked) + span:not(.lever):before {
  transform: rotateZ(37deg) translateY(6.5px);
}

[type="checkbox"].filled-in:checked + span:not(.lever),
[type="checkbox"] + span:not(.lever) {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: #555A63;
  padding-left: 16px;
  padding-top: 2px;
}

[type="checkbox"].filled-in:checked + span:not(.lever):after {
  border: 2px solid $brand-color;
  background-color: $brand-color;
  height: 12px;
  width: 12px;
  transform: translateY(6.5px);
}

[type="checkbox"].filled-in:checked + span:not(.lever):before {
  top: 4px;
  left: 0;
  width: 6px;
  height: 9px;
}

[type="checkbox"].filled-in:not(:checked) + span:not(.lever):after {
  height: 12px;
  width: 12px;
  border: 1px solid #B8B5C8;
  box-sizing: border-box;
  border-radius: 2px;
  transform: translateY(6.5px);
  background: white;
}

[type="checkbox"].filled-in + span:not(.lever):before,
[type="checkbox"].filled-in + span:not(.lever):after {

}

.ev_description {
  white-space: pre-wrap;
}

.text {
  white-space: pre-wrap;
}

button,
input,
optgroup,
select,
textarea,
.btn {
  font-family: 'Source Sans Pro', sans-serif;
}

.page_bg {
  padding-top: 30px;
}

.active_color {
  color: $brand-color;
}

.delimiter {
  color: #A4A0BA;
  padding: 0 10px;
}

.inactive_color {
  color: #A4A0BA;
}

.z-depth-1-half, .btn:hover, .btn-large:hover, .btn-small:hover, .btn-floating:hover {
  box-shadow: none;
}

input {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: #555A63;
}

[type="checkbox"]:checked + span:not(.lever):before {
  border-right: 2px solid $brand-color;
  border-bottom: 2px solid $brand-color;
}

button {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 19px;
  text-align: center;
  text-transform: uppercase;
}

.uppercase {
  text-transform: uppercase;
}

.empty_state_wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media screen and (max-width: 600px) {
    min-height: 70vh;
  }

  .logged & {
    max-height: calc(100vh - 180px);
  }

  .empty_state_text {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: #A4A0BA;
  }

  img {
    max-height: 100%;
    max-width: 100vw;
    margin-bottom: 30px;
  }
}

.main-title {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 28px;
  color: #272727;
}

.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.wrap_any {
  overflow-wrap: anywhere;
}

.block_tags {
  display: flex;
  margin-top: 15px;
  flex-wrap: wrap;
  justify-content: flex-start;

  .tag {
    background: white;
    padding: 8px 15px;
    border-radius: 10px;
    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
    margin: 5px 6px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    svg {
      margin-right: 4px;
    }
  }
}

.main_event_info_widget {
  background: #FFFFFF;
  box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
  border-radius: 12px;
  padding: 15px;

  .info_row {
    font-size: 15px;
    color: #555A63;
    padding-bottom: 15px;
    display: flex;
    align-items: center;

    &:last-child {
      padding-bottom: 0;
    }

    span {
      padding-right: 5px;

      &.img {
        line-height: 0;
      }

      &.conv_starters {
        padding-left: 6px;
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;
        color: #272727;
      }
    }
  }
}

.dress_code_card {
  background: rgba(85, 90, 99, 0.05);
  border-radius: 24px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .content_part {
    padding: 0 20px;
    width: 100%;

    .title {
      font-weight: bold;
      font-size: 15px;
      line-height: 20px;
      color: #272727;
    }

    .content {
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      color: #555A63;
      overflow-wrap: anywhere;
    }
  }

  .img_part {
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
    border-radius: 12px;
  }
}

.full_width {
  width: 100%;
}

.wrapper_center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.wrapper_between {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.strong {
  font-weight: bold;
}

.autocomplete-content {
  top: 46px !important;
  max-height: 300px !important;
  width: 100%;

  span, li, li > span {
    color: #555A63;

    &.highlight {
      color: #fa604a;
    }
  }
}

.tags_wrapper {
  display: flex;
  flex-wrap: wrap;

  .app_tag {
    margin: 3px 9px 3px 0;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
    background: white;
    font-size: 15px;
    line-height: 20px;
    color: #555A63;
    width: fit-content;
    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
    border-radius: 12px;

    img, svg {
      margin-left: 11px;
      cursor: pointer;

      &.left {
        margin-right: 11px;
        margin-left: 0;
        cursor: auto;
      }

      &:hover {
        path {
          stroke: #d3281c;
          fill: #d3281c;
        }
      }
    }
  }
}

.sub_title {
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  color: #272727;
  margin: 30px 0 15px;
}

.table_wrapper {
  width: 100%;
  padding: 50px 0 0;

  .title_col {
    & > span {
      max-width: 250px;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-style: normal;
      font-weight: bold;
      font-size: 13px;
      line-height: 16px;
      color: #555A63;
    }
  }

  .vgt-wrap__footer .footer__navigation__page-btn .chevron {
    display: none;
  }

  .vgt-wrap__footer {
    border: none;
    background: none;
    box-shadow: none;
  }

  .footer__row-count__label {
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    color: #B8B5C8;
  }

  .vgt-wrap__footer {

    .footer__row-count::after {
      border-top: 6px solid $brand-color;
      right: 16px;
    }

    .footer__row-count__select {
      padding: 16px 40px 16px 16px;
      background: white;
      border: 1px solid #DADEED;
      border-radius: 4px;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      color: #555A63;
      cursor: pointer;
    }

    .footer__navigation {
      display: flex;
      align-items: center;
      padding: 0;

      .footer__navigation__page-info {
        order: 1;

        div {
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          color: #555A63;
        }
      }

      & > button:last-child {
        order: 3;
      }
    }

    .footer__navigation__page-btn {
      background: #FFFFFF;
      box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
      border-radius: 12px;
      font-weight: bold;
      font-size: 15px;
      line-height: 19px;
      color: #FA604A;
      height: 56px;
      min-width: 80px;
      padding: 0 22px;

      &.disabled {
        background: #DADEED;
        color: white;
        box-shadow: none;
        opacity: 1;
      }

      span {
        font-weight: bold;
        font-size: 15px;
        line-height: 19px;
      }
    }
  }

  .vgt-wrap__footer .footer__navigation > button:first-of-type {
    margin-right: 0;
  }

  table.vgt-table {
    border: none;
    background: none;
    box-shadow: none;
    border-collapse: separate;
    border-spacing: 0 16px;

    tr, td {
      border: none;
    }

    th.sortable {
      button {
        cursor: pointer;
      }

      & > span {
        position: relative;

        &::before {
          content: "";
          position: absolute;
          height: 0;
          width: 0;
          right: -16px;
          top: 50%;
          margin-bottom: -7px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid #A4A0BA;
        }

        &::after {
          content: "";
          position: absolute;
          height: 0;
          width: 0;
          right: -16px;
          top: 50%;
          margin-top: -7px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #A4A0BA;
        }
      }

      &.sorting-desc {
        span {
          color: #70747d;
          font-weight: bold;

          &:before {
            border-top: 5px solid #FA604A;
          }
        }
      }

      &.sorting-asc {
        span {
          color: #70747d;
          font-weight: bold;

          &:after {
            border-bottom: 5px solid #FA604A;
          }
        }
      }

      button:before {
        display: none;
        border-top: 5px solid #A4A0BA;
      }

      button:after {
        display: none;
        border-bottom: 5px solid #A4A0BA;
      }

      &.sorting-asc button:after {
        border-bottom: 5px solid #FA604A;
      }

      &.sorting-desc button:before {
        border-top: 5px solid #FA604A;
      }
    }

    thead {
      th {
        border: none;
        color: #A4A0BA;
        background: #F5F7FD;
        padding: 30px .75em;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
        cursor: pointer;
      }
    }

    tbody td {
      padding: 1.1em .75em;
      font-weight: 600;
    }

    tbody tr {
      padding-bottom: 10px;
      background: white;
      height: 60px;
      border-radius: 4px;
      overflow: auto;

      &.clickable:hover {
        box-shadow: 3px 6px 12px rgb(58 1 67 / 5%);
        background: white;
        transform: translate(-2px, -2px);
      }
    }

  }

  .vgt-inner-wrap {
    border: none;
    box-shadow: none;
  }
}

.title_text {
  font-size: 22px;
  line-height: 28px;
  color: #272727;
  font-weight: bold;
}

.select-dropdown > li > span {
  color: $brand-color;
}

.modal.datepicker-modal,
.modal.timepicker-modal {
  .timepicker-digital-display,
  .datepicker-date-display,
  .is-selected,
  .month-prev:focus,
  .month-next:focus,
  .timepicker-tick:focus,
  .timepicker-tick:hover,
  .datepicker-day-button:focus {
    background: $brand-color;
  }

  .is-today.is-selected {
    color: white;
  }

  .timepicker-svg {
    line {
      stroke: $brand-color;
    }

    .timepicker-canvas-bg,
    .timepicker-canvas-bearing {
      fill: $brand-color;
    }
  }

  .is-today,
  .btn-flat {
    color: $brand-color;
  }
}

.datepicker-controls .select-month input {
  width: 90px;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn_main {
  width: 202px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #FA604A 0%, #9235A1 100%);
  border-radius: 24px;
  overflow: hidden;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #FFFFFF;
  border: none;
  transition: all .2s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }
}

#toast-container {
  .toast {
    background: rgba(255, 255, 255, 1);
    font-size: 16px;
    color: black;
    font-weight: 600;

    &.err {
      color: #c90404;
    }

    &.info {
      color: #04a504;
    }
  }
}

.modal:not(.datepicker-modal, .timepicker-modal) {
  border-radius: 12px;

  .modal_header {
    position: relative;
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    color: #272727;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 15px 18px;
    background: white;

    .close_modal_btn {
      right: 30px;
      position: absolute;
      top: calc(50% - 7px);
      cursor: pointer;
      display: flex;

      img {
        height: 15px;
        width: auto;
      }
    }
  }

  .close_modal_btn {
    &:hover {
      svg {
        path {
          stroke: #d3261b;
          fill: #d3281c;
        }
      }
    }
  }

  .w180 {
    width: 180px;
    max-width: 100%;
  }

  .modal-content {
    background: $page_bg;
    padding: 0 30px 30px;
    min-width: 100%;
    width: 480px;
    max-width: 100%;

    p {
      text-align: center;
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      color: $text-color;
      margin: 0;
      padding: 30px 0;
    }

    .content_title {
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 23px;
      text-align: center;
      color: #272727;
      padding-bottom: 0;
    }
  }

  &.content-width {
    width: max-content;
    max-width: 95vw;
  }

  @media screen and (max-width: 601px) {
    width: 95%;
    &.content-width {
      width: 95%;;
      max-width: 95vw;
    }
  }
}

.row > .col.no_padding {
  padding: 0;
}

.w100 {
  width: 100%;
}

nav {
  height: 80px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  background-size: cover;
  background: linear-gradient(
                  90deg, #FA604A 0%, #9235A1 100%) no-repeat center;

  .event_details & {
    height: 413px;
  }

  .profile & {
    height: 453px;
  }

  @media screen and (max-width: 601px) {
    height: 54px;

    .event_details & {
      height: 192px;
    }
  }
}

.error-message {
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: $error-message;
  text-align: center;
  margin-bottom: 1rem;
}

.dropdown-content:not(.select-dropdown) {
  width: 100%;

  @media screen and (max-width: 601px) {
    transform: none;
  }
}

.autocomplete-content.dropdown-content {
  width: 100% !important;
}

.modal.h90 {
  max-height: 90%;
}

.modal.datepicker-modal, {
  .orig-select-year, .orig-select-month {
    @media screen and (max-width: 601px) {
      display: block;
      position: absolute;
      top: 0;
      width: 100%;
      max-width: 90vh;
      z-index: 1;
      opacity: 0;
    }
  }
}

#app {
  background: $page_bg;
  min-height: 100%;
}

#app :not(.modal.datepicker-modal) :not(.modal.timepicker-modal) .input-field {
  & > input,
  & > .pseudo_input,
  & > textarea,
  & > textarea.materialize-textarea {
    background: #FBFCFF;
    border: 1px solid #DADEED;
    box-sizing: border-box;
    border-radius: 4px;
    padding-left: 12px;
    box-shadow: none;
    color: #555A63;
    font-size: 15px;

    &:disabled {
      background: $disabled_input;
      color: #B8B5C8;
    }

    &::placeholder {
      color: #A4A0BA;
    }
  }

  .drop_down_icon {
    content: '';
    width: 13px;
    height: 12px;
    background: url("./assets/img/down.svg") no-repeat;
    background-size: cover;
    position: absolute;
    right: 20px;
    top: 16px;
  }

  select {
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 0;
    top: 0;
    max-width: 100vw;
  }

  label {
    color: #A4A0BA;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    padding-left: 12px;
    padding-bottom: 2px;
    transform: translateY(12px);

    &.active {
      transform: translate(-10px, -20px) scale(0.86);
    }
  }

  input:not([type]):focus:not([readonly]),
  input[type=text]:not(.browser-default):focus:not([readonly]),
  input[type=password]:not(.browser-default):focus:not([readonly]),
  input[type=email]:not(.browser-default):focus:not([readonly]),
  input[type=url]:not(.browser-default):focus:not([readonly]),
  input[type=time]:not(.browser-default):focus:not([readonly]),
  input[type=date]:not(.browser-default):focus:not([readonly]),
  input[type=datetime]:not(.browser-default):focus:not([readonly]),
  input[type=datetime-local]:not(.browser-default):focus:not([readonly]),
  input[type=tel]:not(.browser-default):focus:not([readonly]),
  input[type=number]:not(.browser-default):focus:not([readonly]),
  input[type=search]:not(.browser-default):focus:not([readonly]),
  textarea.materialize-textarea:focus:not([readonly]) {
    border: 1px solid #B8B5C8;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    color: #555A63;
  }
}

.card {
  box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.15);
  border-radius: 12px;
  max-height: 100vh;
  max-width: 95vw;
  min-width: 50%;
  overflow-y: auto;

  .card-content {
    padding: 30px;
  }

  @media screen and (min-width: 1199px) {
    min-width: 30%;
  }
}

.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}

.btn.white,
.btn.white:active,
.btn.white:visited,
.btn.white:focus {
  padding: 18px 16px;
  background: white;
  color: $brand-color;
  font-size: 15px;
  font-weight: 700;
  line-height: 19px;
  box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
  border-radius: 12px;

  img, svg {
    margin-right: 12px;

    &.right {
      margin-right: 0;
      margin-left: 12px;
    }
  }

  &.logout {
    height: 40px;
    width: 80px;
    min-height: 40px;
    min-width: 80px;
    padding: 0;
    text-transform: none;
  }

  &:hover {
    color: #d3281c;

    svg {
      path {
        stroke: #d3261b;
        fill: #d3281c;
      }
    }
  }
}

.btn.white:hover svg path, .btn.white:active:hover svg path, .btn.white:visited:hover svg path, .btn.white:focus:hover svg path {
  stroke: none;
  fill: #d3281c;
}

.btn.white.stroke:hover svg path, .btn.white.strok:active:hover svg path, .btn.white.strok:visited:hover svg path, .btn.white.strok:focus:hover svg path {
  stroke: #d3281c;
}

.btn.white.stroke:hover span,
.view_all:hover,
.view_all:hover span {
  color: #d3281c !important;
}

.card_title {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 28px;
}

.btn,
.btn:active,
.btn:visited,
.btn:focus {
  background: $brand-color;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px;
  box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  line-height: 19px;
  color: white;
  min-width: 178px;
  min-height: 56px;

  &:hover {
    background: #d3261b;
  }
}

.btn_wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buttons_wrapper_between {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.two {
    & > .btn {
      width: calc(50% - 15px);
    }
  }

  &.center {
    justify-content: center;
  }
}

.btn_link {
  font-weight: bold;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: $brand-color;
  cursor: pointer;

  &:hover {
    color: #D3251A;
  }
}

.background_image_main {
  background-image: linear-gradient(90deg, #fa604a99 0%, #9235A199 100%), url("assets/img/background_image_user.svg");
  background-repeat: no-repeat;
  background-size: cover;
  min-height: calc(100vh - 80px);

  @media screen and (max-width: 601px) {
    min-height: calc(100vh - 54px);
  }
}

.center-card {
  display: flex;
  justify-content: center;
  align-items: center;

  .card {
    @media screen and (max-width: 601px) {
      width: 95%;
    }
  }
}

.ev_description {
  margin: 30px 0;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: #555A63;
  overflow-wrap: anywhere;
}

.page_bg {
  background: $page_bg;
  min-height: calc(100vh - 80px);
  width: 100%;
  max-width: 100%;
  padding: 30px 8%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;

  &.hidden,
  .logged &.hidden {
    min-height: 0;
    height: 0;
    overflow: hidden;
    padding: 0;
  }

  .event_details.logged & {
    overflow: visible;
    min-height: 340px;
    height: auto;

    @media screen and (max-width: 601px) {
      min-height: 100vh;
    }

    .main_row {
      margin-top: -332px;
      flex: 1;

      @media screen and (max-width: 601px) {
        margin-top: -72px;
        padding: 0 14px;
      }
    }
  }

  .logged & {
    min-height: calc(100vh - 160px);
    //height: calc(100vh - 160px);

    @media screen and (max-width: 601px) {
      min-height: calc(100vh - 54px);
    }
  }

  @media screen and (max-width: 601px) {
    padding: 0;
    min-height: calc(100vh - 54px);
  }
}

.pointer {
  cursor: pointer;
}

.nav_friending {
  padding: 0 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  .brand-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}

a {
  text-decoration: none;
}

#event_info .modal-content {
  padding: 0px !important;
}

#modal_filter {
  /* scrollbar */
  .autocomplete-content.dropdown-content {
    scrollbar-color: #FA604A #F2F4FC;
    scrollbar-width: thin;
    height: auto;
    max-height: 140px !important;

    &::-webkit-scrollbar {
      width: 10px;
      height: 8px;
      background-color: #F2F4FC;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #FA604A;
      border-radius: 5em;
    }
  }
}

.friend-item {
  .first-block {
    border-bottom: solid white 4px;
  }
}

.VuePagination {
  height: 40px;

  nav {
    height: auto;
    background: unset;
    box-shadow: unset;

    @media screen and (max-width: 601px) {
      display: flex;
      flex-direction: column;
      align-items: center;

      ul {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    p {
      color: black;
      line-height: 40px;
    }

    ul {
      li {
        height: auto;
        line-height: normal;
        margin: 0 5px;
        border-radius: 6px;
        overflow: hidden;

        @media screen and (max-width: 601px) {
          margin: 0;
        }

        a {
          line-height: normal;
          font-weight: 600;
          padding: 8px 12px;

          &[disabled='disabled'] {
            &:hover {
              background: none;
            }
          }
        }
      }
    }
  }
}
</style>

